import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Input,
  Table,
  TableCaption,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Tfoot,
  TableContainer,
  List,
  ListItem,Select,
  Button
} from "@chakra-ui/react";
import toast from 'react-hot-toast';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
import "jspdf-autotable";
//import toast from 'react-hot-toast';

const DailyTransferSummary = () => {
  const [data, setData] = useState([]);
  const [wineData, setWineData] = useState([]);
  const [payment, setPayment] = useState({});
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState(new Date());
  const [searchItem, setSearchItem] = useState('');
  const [unit,setUnit]=useState('')
  const [foodData, setFoodData] = useState([]);
  const [filteredFoodData, setFilteredFoodData] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1); // Track selected item index

  const customerId = localStorage.getItem('customerId');

  const fetchData = async () => {
    try {
      const response = await axios.get(`https://api.rcb.tdrsoftware.in/api/getTransferSalesSummary/${customerId}?startDate=${startDate}&endDate=${endDate}&searchItem=${searchItem}`);
      setData(response.data.TransferSummary);
      
    } catch (error) {
     // toast.error('Error fetching data');
    }
  };
  console.log(data,'data')

  const fetchFoodData = async () => {
    try {
      const response = await axios.get(`https://api.rcb.tdrsoftware.in/api/item/${customerId}`);
      setFoodData(response.data.item);
      setFilteredFoodData(response.data.item);  // Initial filtered data to all items
    } catch (error) {
      toast.error('Error fetching Item data');
    }
  };

  useEffect(() => {
    fetchData();
    fetchFoodData();
  }, [customerId, startDate, endDate, searchItem]);
  
  // Export to Excel function
  const consolidateDataForExcel = () => {
    const consolidatedData = [];
    const maxRows = Math.max(data.length, 1); // 1 for at least the payment row
  
    // Initialize total quantities and amounts
    let totalItemQuantity = 0;
   
  
    for (let i = 0; i < maxRows; i++) {
      // Accumulate total quantities and amounts for food
      totalItemQuantity += data[i]?.totalQuantity || 0;
      
  
      consolidatedData.push({
        Item_Name: data[i]?._id || '',
        
        Total_Quantity: data[i]?.totalQuantity || '',
        Unit: data[i]?.unit || '',
        
      });
    }
  
    // Add a final row for totals
    consolidatedData.push({
      Item_Name: 'Total',
      
      Total_Quantity: totalItemQuantity,
     
    });
  
    return consolidatedData;
  };
  
  const exportToExcel = () => {
    const dataToExport = consolidateDataForExcel();
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Daily Transfer Summary");
    
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${startDate}-${endDate}-DailyTransferSummary.xlsx`);
  };
  const exportToPDF = () => {
    const dataToExport = consolidateDataForExcel();
    
    // Initialize jsPDF
    const pdf = new jsPDF();
  
    // Define the columns for the table
    const columns = [
      { header: "Item Name", dataKey: "Item_Name" },
     
      { header: "Total Quantity", dataKey: "Total_Quantity" },
      { header: "Unit", dataKey: "Unit" },
      
    ];
  
    // Add title to PDF
    pdf.text("Daily Transfer Summary", 14, 20);
  
    // Add autoTable to render the data in a table format
    pdf.autoTable({
      startY: 30,
      head: [columns.map(col => col.header )],
      body: dataToExport.map(row => columns.map(col => row[col.dataKey] || "")),
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [0, 57, 107],
        textColor: [255, 255, 255]
      }
    });
  
    // Save the PDF
    pdf.save(`${startDate}-${endDate}DailyTransferSummary.pdf`);
  };

  // Filter foodData based on searchItem input
  useEffect(() => {
    if (searchItem) {
      const filtered = foodData.filter(item => item.name.toLowerCase().includes(searchItem.toLowerCase()));
      setFilteredFoodData(filtered);
    } else {
      setFilteredFoodData(foodData);
    }
    setHighlightedIndex(-1); // Reset the highlight when search input changes
  }, [searchItem, foodData]);

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      setHighlightedIndex((prevIndex) =>
        prevIndex < filteredFoodData.length - 1 ? prevIndex + 1 : 0
      );
    } else if (e.key === 'ArrowUp') {
      setHighlightedIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : filteredFoodData.length - 1
      );
    } else if (e.key === 'Enter' && highlightedIndex >= 0) {
      // Set the search input to the selected item
      setSearchItem(filteredFoodData[highlightedIndex].name);
      setFilteredFoodData([]) // Clear suggestions after selection
    }
  };

  return (
    <Box>
      <Box display='flex' flexDirection='row' justifyContent='center' gap={3} p={5} mb={10}>
        <Input
          width='20% '
          type='date'
          name='startDate'
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <Input
          width='20%'
          type='date'
          name='endDate'
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
        <Box width='20%' position="relative">
          <Input
            placeholder="Search Item"
            value={searchItem}
            onChange={(e) => setSearchItem(e.target.value)}
            onKeyDown={handleKeyDown} // Add keydown handler for arrow navigation
          />
          <List position="absolute" bg="white" zIndex="1" width="100%" maxHeight="150px" overflowY="auto">
            {filteredFoodData.map((item, index) => (
              <ListItem
                key={index}
                bg={index === highlightedIndex ? "gray.200" : "white"}
                padding="5px"
                cursor="pointer"
                onMouseEnter={() => setHighlightedIndex(index)}
                onMouseLeave={() => setHighlightedIndex(-1)}
                onClick={() => setSearchItem(item.name)} // Set item on click
              >
                {item.name}
              </ListItem>
            ))}
          </List>
         
        </Box>
        <Button colorScheme='green' onClick={exportToExcel}>Export Excel</Button>
        <Button colorScheme='red' onClick={exportToPDF}>Export Pdf</Button>
      </Box>

      <Box width='60%' mt={150} bg='#E3D9FC'>

      <TableContainer width='full' p={2}>
        <Table size='sm' variant='striped' colorScheme='green'>
          <TableCaption>Daily Transfer Summary</TableCaption>
          <Thead>
            <Tr>
              <Th>Transfer Item</Th>
              
            </Tr>
          </Thead>
          <Tbody>
            <Td>
              {/* Food Sales Table */}
              <Table size='xsm' variant='striped' colorScheme='orange'>
                <TableCaption>Itemwise Transfer Summary</TableCaption>
                <Thead>
                  <Tr>
                    <Th>Name</Th>
                    
                    <Th>Qty</Th>
                    <Th>Unit</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data.map((item, index) => (
                    <Tr key={index}>
                      <Td>{item._id}</Td>
                     
                      <Td>{item.totalQuantity}</Td>
                      <Td>{item.unit}</Td>
                    </Tr>
                  ))}
                </Tbody>
                <Tfoot >
                <tr>
    <td colSpan={3} style={{textAlign: 'center',fontWeight:'bold',marginRight:"25px",fontSize:'15px'}}>
     Total Qty: {data.reduce((total, item) => total + item.totalQuantity, 0)}
    </td>
    {/* <td colSpan={4} style={{textAlign: 'right',marginRight:'20px',fontWeight:'bold',padding:"5px",fontSize:'15px'}}>
     Total Amt: {data.reduce((total, item) => total + item.totalAmount, 0)}
    </td> */}
  </tr>
                </Tfoot>
              </Table>
            </Td>
          
          </Tbody>
        </Table>
      </TableContainer>
      </Box>
    </Box>
  );
};

export default DailyTransferSummary;
